import { ArrowRightOutlined } from '@ant-design/icons'
import { Alert } from 'antd-v4'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { ReportFilterStore } from '../ReportFilterStore'
import { browserHistory } from 'react-router'

interface IReportAlert {
  reportType: 'advanced' | 'insights'
  reportFilterStore?: ReportFilterStore
  reportPath: string
}

export const ReportAlert: React.FC<IReportAlert> = inject('reportFilterStore')(
  observer((props) => {
    const { reportFilterStore } = props

    const toReports = () => {
      if (!reportFilterStore) {
        return
      }
      reportFilterStore.setIsFirstLoad(true)
      browserHistory.push({
        pathname: props.reportPath,
        query: {
          startDate: reportFilterStore.startDateString,
          endDate: reportFilterStore.endDateString,
          locationIds: reportFilterStore.selectedLocationIds,
        },
      })
    }

    return (
      <Alert
        className='mb-3'
        message={
          <a style={{ color: 'black', textDecorationLine: 'underline' }} onClick={toReports}>
            Go to{' '}
            <strong>{props.reportType === 'advanced' ? 'Advanced' : 'Insights'} Report</strong> for
            faster reports, including access to data beyond the last 3 months.{' '}
            <ArrowRightOutlined />
          </a>
        }
        type='success'
      />
    )
  }),
)
